import { render, staticRenderFns } from "./EsamiSpecialisticiEditComponent.vue?vue&type=template&id=35659909"
import script from "./EsamiSpecialisticiEditComponent.vue?vue&type=script&lang=js"
export * from "./EsamiSpecialisticiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports